/*
https://splidejs.com/guides/getting-started/
*/

import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const slider = document.querySelector('.featured-media .splide');

if( slider ) {
    var splide = new Splide( '.featured-media .splide' , {
        type: 'loop',
        rewind: true,
        speed: 1000,
        arrows: false,
        pagination: false,
        perPage: 5,
        perMove: 1,
        gap: 50,
        autoScroll: {
            speed: .8,
        },
        breakpoints: {
            1024: {
                perPage: 4,
            },
            960: {
                perPage: 3,
                gap: 30,
            },
            768: {
                perPage: 2,
            },
        }
    });
    splide.mount({ AutoScroll });
}